import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { LoaderService } from '../../_services/loader.service';
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2';


declare var $: any;
const distinctFuelType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.FULETYPE === x.FULETYPE) === idx);
const distinctZone = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.Zone === x.Zone) === idx);
const distinctVehCategory = (data) =>
	data.filter((x, idx, xs) => xs.findIndex((y) => y.vehcatName === x.vehcatName) === idx);
const distinctVehType = (data) =>
	data.filter((x, idx, xs) => xs.findIndex((y) => y.vehicleType === x.vehicleType) === idx);
export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};

@Component({
	selector: 'FuelTemp-cmp',
	templateUrl: './fuelTemp.component.html',
	styleUrls: ['./fuelTemp.component.css'],
})
export class FuelTempComponent {
	prjId: any;
	showLoader: boolean;
	startDate: any;
	endDate: any;
	defStartDt: any;
	defEndDt: any;
	dateRange: any;
	fuelReportList: any;
	purchaseImg: any;
	fuelAmnt: any;
	fuelQty: any;
	rowCount: any;
	public state: State = {
		skip: 0,
		take: 12,
		filter: {
			logic: 'and',
			filters: []
		}
	};
	public pageSize: any;
	public checkboxOnly = false;
	public mode = 'multiple';
	public selectableSettings: SelectableSettings;

	public allData(): ExcelExportData {
		const result: ExcelExportData = {
			data: this.fuelReportList
		};
		return result;
	}

	public groups: GroupDescriptor[] = [];
	public view: Observable<GridDataResult>;

	public gridDataFuelReport: DataResult;
	public groupChange(groups: GroupDescriptor[]): void {
		this.groups = groups;
		this.loadProducts();
	}
	public distinctFuelType: any[];
	public distinctVehCategory: any[];
	public distinctZone: any[];
	public distinctVehType: any[];
	loaderClass: any;
	syncing: any;
	private loadProducts(): void {
		this.gridDataFuelReport = process(this.fuelReportList, { group: this.groups });
	}
	constructor(
		private http: HttpClient,
		private auth: AuthService,
		public routes: ActivatedRoute,
		public router: Router,
		private loaderService: LoaderService
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.allData = this.allData.bind(this);
		var date = new Date();
		this.defStartDt = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.defEndDt = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.dateRange = {
			beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },
			endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
		};
		this.fuelAmnt = 0;
		this.fuelQty = 0;
		this.rowCount = 0;
	}

	/*
  * get Fuel Report List
  */
	getFuelRepoerList() {
		this.fuelAmnt = 0;
		this.fuelQty = 0;
		var qty = 0;
		var amnt = 0;
		this.loaderService.display(true);
		var fuelType = 'Purchse_Vehicle';
		this.http
			.get(
				environment.apiUrl +
					'reports/getFuelReport?prjid=' +
					this.prjId +
					'&fuelType=' +
					fuelType +
					'&startDate=' +
					this.startDate +
					'&endDate=' +
					this.endDate
			)
			.subscribe((data) => {
				this.fuelReportList = data;
				if (this.fuelReportList.length > 0) {
					this.rowCount = this.fuelReportList.length;
					this.distinctFuelType = distinctFuelType(this.fuelReportList);
					this.distinctZone = distinctZone(this.fuelReportList);
					this.distinctVehCategory = distinctVehCategory(this.fuelReportList);
					this.distinctVehType = distinctVehType(this.fuelReportList);
					this.gridDataFuelReport = process(this.fuelReportList, this.state);
					this.loaderService.display(false);
				} else {
					this.loaderService.display(false);
					this.gridDataFuelReport = null;
				}
				for (var i = 0; i < this.fuelReportList.length; i++) {
					qty = Number(qty) + Number(this.fuelReportList[i].QTY);
					amnt = Number(amnt) + this.fuelReportList[i].AMOUNT;
					this.fuelQty = Number(qty).toFixed(2);
					this.fuelAmnt = Number(amnt).toFixed(2);
				}
			});
	}

	/*
   * filter The Grid Data
  */
	public dataStateChange(state: DataStateChangeEvent): void {
		this.state = state;
		this.gridDataFuelReport = process(this.fuelReportList, this.state);
		if (state && state.group) {
			this.distinctFuelType = distinctFuelType(this.fuelReportList);
			this.distinctZone = distinctZone(this.fuelReportList);
			this.distinctVehCategory = distinctVehCategory(this.fuelReportList);
			this.distinctVehType = distinctVehType(this.fuelReportList);
			this.gridDataFuelReport = process(this.fuelReportList, this.state);
		}
	}

	/*
  *select start Date Nad To date
  */
	onDateRangeChanged(dataRange) {
		if (dataRange.beginDate.day > 0) {
			this.startDate = dataRange.beginDate.year + '-' + dataRange.beginDate.month + '-' + dataRange.beginDate.day;
			this.endDate = dataRange.endDate.year + '-' + dataRange.endDate.month + '-' + dataRange.endDate.day;
			this.getFuelRepoerList();
		} else if (dataRange.beginDate.day == 0) {
			this.startDate = this.defStartDt;
			this.endDate = this.defEndDt;
			this.getFuelRepoerList();
		}
	}

	/*
  * Zoom Image
  */
	zomeFuelImg(data) {
		console.log('data', data);
		this.purchaseImg = data.IMGURL;
		$('#fuelPurchaseImg').modal('show');
	}
	syncData() {
		this.syncing = true;
		this.loaderClass = 'fas fa-sync fa-spin';
		this.http
			.get(environment.apiUrl + 'fuelMobility/queryFirebase?prjId=' + this.prjId + '&fromdate=' + this.startDate + '&todate=' + this.endDate)
			.subscribe((data) => {
				var result = data[0]
				if(result.status_code == 200){
					this.getFuelRepoerList();
					setTimeout(() => {
						this.loaderClass = 'fas fa-sync';
						this.syncing = false;
					}, 10000);
					Swal({
						type: 'success',
						title: 'Success',
						text: 'Syncing is started. It may take some time to reflect.',
					})
				}
				else {
					this.getFuelRepoerList();
					setTimeout(() => {
						this.syncing = false;
						this.loaderClass = 'fas fa-sync';
					}, 10000);
					Swal({
						type: 'error',
						title: 'Oops....',
						text: 'There was an error. Please try again later.',
					})
				}
			});
	}

	addFuel(){
		$('#addFuelModal').modal('show');
	}

	ngOnInit() {
		this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
		this.endDate = moment(this.defEndDt).format('YYYY-MM-DD');
		this.prjId = this.auth.getAuthentication().projectId;
		this.getFuelRepoerList();
		this.loaderClass = 'fas fa-sync';
		this.syncing = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/fuel/fuelTemp.component.ts